import {
  EstimateFieldFilter,
  EstimateFieldFilterOperationType,
  EstimateRelativeDirection,
} from 'module/types/filter-field/filter/estimate';
import { Menu } from 'module/ui/components/atoms/dropdown';
import { renderRelativeMenuItem } from './relative-menu-item';

export const renderOverlay = (
  filter: EstimateFieldFilter,
  onChange: (filter: EstimateFieldFilter) => void,
) => (
  <Menu
    className="date-criteria"
    selectable
    selectedKeys={[filter.type.toString()]}
    onSelect={({ key }) => {
      const type = key as EstimateFieldFilterOperationType;

      onChange({
        ...filter,
        type,
        days: (filter as EstimateFieldFilter).days,
        direction:
          (filter as EstimateFieldFilter).direction ??
          EstimateRelativeDirection.Early,
      } as EstimateFieldFilter);
    }}
  >
    {renderRelativeMenuItem(
      filter,
      EstimateFieldFilterOperationType.IsMoreThan,
      onChange,
    )}
    {renderRelativeMenuItem(
      filter,
      EstimateFieldFilterOperationType.IsLessThan,
      onChange,
    )}
  </Menu>
);
